import React from 'react';
import styled from 'styled-components';

import RouterLink from 'components/basic/Link/RouterLink';
import VaultIconSvg from 'components/vaults/images/VaultIconSvg';
import { useSelector } from 'reduxState/storeCore';

import { useOwnVaultQuery } from '../shared/utils';

const LinkStyled = styled(RouterLink)`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 18px 1px;

  cursor: pointer;
  color: var(--main);
  font-size: var(--small);
  font-style: normal;
  font-weight: normal;
  line-height: 1;
`;

/** When available (for vault owner) it displays Link to Vault */
export default function VaultHeaderLink() {
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const ownVault = useOwnVaultQuery();

  if (!ownVault) {
    return null;
  }
  return (
    <LinkStyled to={`/vaults/${walletAddress}`}>
      <VaultIconSvg marginTop="-1px" /> {ownVault.name || 'Vault'}
    </LinkStyled>
  );
}
